import React, { useEffect, useState } from 'react';
import { CtaButton, ModalContainer } from '@tassomutuo-backoffice/ui';
import { Profile } from '@tassomutuo-backoffice/types';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { ProfileInputsForm } from '../../../../components';

interface IFormInputs {
  email: string;
  name: string;
  lastName: string;
  provinces: string[];
  createdBy: string;
  profileImage: File | string | null;
  htmlDescription: string;
  published: boolean;
}

interface IProps {
  open: boolean;
  handleClose: () => void;
  profileToUpdate: Profile | null;
  onSubmitProfileToUpdate: (
    data: IFormInputs & { intranetUserId: string }
  ) => Promise<void>;
  onSubmitProfileToCreate: (data: IFormInputs) => Promise<void>;
}

const ModalProfileForm = ({
  open,
  profileToUpdate,
  handleClose,
  onSubmitProfileToUpdate,
  onSubmitProfileToCreate,
}: IProps) => {
  const methods = useForm<IFormInputs>();

  const { handleSubmit, reset } = methods;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (profileToUpdate) {
      reset({
        email: profileToUpdate?.email || '',
        name: profileToUpdate?.name || '',
        lastName: profileToUpdate?.lastName || '',
        provinces: profileToUpdate?.tassomutuoProfile?.provinces || [],
        createdBy: profileToUpdate?.tassomutuoProfile?.createdBy || '',
        profileImage:
          profileToUpdate?.tassomutuoProfile?.profileImageUrl || null,
        htmlDescription:
          profileToUpdate?.tassomutuoProfile?.htmlDescription || '',
        published: profileToUpdate?.tassomutuoProfile?.published || false,
      });
    }
  }, [profileToUpdate]);

  const onCloseHandler = () => {
    handleClose();
    reset({
      email: '',
      name: '',
      lastName: '',
      provinces: [],
      createdBy: '',
      profileImage: null,
      htmlDescription: '',
      published: false,
    });
  };

  const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
    setIsLoading(true);
    try {
      if (!profileToUpdate?.id) {
        await onSubmitProfileToCreate(data);
      } else {
        await onSubmitProfileToUpdate({
          ...data,
          intranetUserId: profileToUpdate.id,
        });
      }
      onCloseHandler();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer
      open={open}
      handleClose={onCloseHandler}
      title="Profilo TassoMutuo"
      containerSx={{ maxWidth: '800px', maxHeight: '100vh' }}
      mtHeader={0}
    >
      <FormProvider {...methods}>
        <Box
          width="100%"
          component="form"
          maxHeight="70vh"
          onSubmit={handleSubmit(onSubmit)}
        >
          <ProfileInputsForm profileToUpdate={profileToUpdate} adminMode />
          <Box display="flex" justifyContent="center" my={4}>
            <CtaButton variant="contained" type="submit" loading={isLoading}>
              SALVA
            </CtaButton>
          </Box>
        </Box>
      </FormProvider>
    </ModalContainer>
  );
};

export default ModalProfileForm;
